module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_03A.87827287.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_03A.mp3
// module id = 114
// module chunks = 0